import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import HeaderLogged from '../../../../../components/header_logged'
import FormEdit from '../../../../../components/auth/institucional/cartaservico/listar/form_edit'
import Head from '../../../../../components/head'


function EditarCartaServicoScreen () {
    return (
        <Fragment>
            <Head titulo="Editando Carta de Serviço ao Cidadão" />
            <HeaderLogged />
            <Container>
                <FormEdit />
            </Container>
        </Fragment>
    );
}

export default EditarCartaServicoScreen;